// removed by extract-text-webpack-plugin
module.exports = {"landingSection":"src-components-LandingSection----styles-module---landingSection---32VNr","title":"src-components-LandingSection----styles-module---title---2cfsq","subtitle":"src-components-LandingSection----styles-module---subtitle---yz8PQ","imageWrapper":"src-components-LandingSection----styles-module---imageWrapper---3pNcw","image":"src-components-LandingSection----styles-module---image---3jp-Q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingSection/styles.module.css
// module id = 504
// module chunks = 168707334958949